export enum TrackEvent {
  ROOM_SESSION_OPENED = 'Room Session Opened',
  ROOM_SESSION_RENAMED = 'Room Session Renamed',
  ROOM_SESSION_DELETED = 'Room Session Deleted',
  AI_RESULT_OPENED = 'AI Result Opened',
  ALL_AI_RESULTS_COPIED = 'All AI Results Copied',
  AI_RESULT_COPIED = 'AI Result Copied',
  AI_RESULT_SCORED = 'AI Result Scored',
  AI_RESULT_DISMISSED = 'AI Result Dismissed',
  AI_RESULT_ACCEPTED = 'AI Result Accepted',
  AI_RESULT_EMAIL_CLICKED = 'AI Result Email Clicked',
  AI_RESULT_OVERRIDE = 'AI Result Override Started',
  AI_ASK_ME_ANYTHING_EXECUTED = 'AI Ask Me Anything Executed',
  AI_FEATURE_RERUN = 'AI Feature Rerun',
  AI_FEATURE_MANUAL_RUN = 'AI Feature Manual Run',
  AI_SYSTEM_PRESET_RUN = 'AI System Preset Run',
  RERUN_AI_RESULT_SAVED = 'Rerun AI Result Saved',
  RERUN_AI_RESULT_REPLACED = 'Rerun AI Result Replaced',
  ON_DEMAND_AI_FEATURES_EXECUTED = 'On-demand AI Features Executed',
  UPLOAD_RECORDING_CLICKED = 'Upload Recording Clicked',
  RECORDING_UPLOADED = 'Recording Uploaded',
  DYNAMIC_AI_FEATURE_EXECUTED = 'AI feature with dynamic context executed',
  SHARE_BUTTON_CLICKED = 'Share Meeting Button Clicked',
  NEW_ALLOCATION_SAVED = 'New Allocation Saved',
  ROOM_SESSION_PROCESSED = 'Meeting Processed',
  ROOM_SESSION_UNPROCESSED = 'Meeting Unprocessed',
  ROOM_SESSION_MEETING_TYPE_CHANGED = 'Meeting Type Changed',
  NOTEPAD_OPENED = 'Notepad Opened',
  AI_RESULT_ADDED_TO_NOTEPAD = 'AI Result Added To Notepad',
  COMMENTS_OPENED = 'Comments Opened',
  AI_RESULT_COMMENTED = 'AI Result Commented',
  AI_RESULT_COMMENT_SAVED = 'AI Result Comment Saved',
  AI_RESULT_EXPLAINED = 'AI Result Explained',
  SWITCHED_TO_SUMMARY_V1 = 'Switched To Meeting Summary V1',
  SWITCHED_TO_SUMMARY_V2 = 'Switched To Meeting Summary V2',
  ROOM_SESSION_ENDED = 'Room Session Ended',
  EXPORT_TO_PDF = 'Export to PDF',
  EXPORT_TO_CSV = 'Export to CSV',
  EVENT_FILTER_CHANGED = 'Event Filter Changed',
  AI_ASSISTANT_ADDED = 'AI Assistant Added',
  CHANGED_TO_IN_PERSON = 'Changed To In-Person',
  CHANGED_PRIVACY = 'Changed Session Privacy',
  CHANGED_TO_PHONE = 'Changed To Phone',
  CHANGED_TO_RINGCENTRAL = 'Changed To RingCentral',
  CHANGED_TO_GOTO = 'Changed To GoTo',
  CHANGED_TO_ZOOM_PHONE = 'Changed To Zoom Phone',
  MENU_ITEM_CLICKED = 'Menu Item Clicked',

  //FORM
  FORM_MANUALLY_EXECUTED = 'Form Manually Executed',
  FORM_RESULT_EDITED = 'Form Result Edited',
  SAVE_FORM_TO_CRM = 'Save form result to CRM Clicked',
  FORM_CREATED = 'New form created',
  FORM_UPDATED = 'Form updated',
  FORM_CLONED = 'Form cloned',
  FORM_RERUN = 'Form Rerun',
  CONTACT_FORM_FILL_OPENED = 'Contact Form Fill Opened',
  CONTACT_FORM_RERUN = 'Contact Form Rerun',
  CONTACT_FORM_EXECUTED = 'Contact Form Executed',
  FORM_CITATION_GENERATED = 'Form Citation Generated',
  FORM_CITATION_CLICKED = 'Form Citation Clicked',
  FORM_RESULT_EXPLAINED = 'Form Result Explained',

  // PLAN EVENTS
  PLAN_PERIOD_CHANGE = 'Plan Period Changed',
  PLAN_MANAGE_PLAN_OPENED = 'Plan Manage Plan Opened',
  PLAN_UPGRADE_PLAN_OPENED = 'Plan Upgrade Plan Opened',
  PLAN_UPGRADE_SEAT_OPENED = 'Plan Upgrade Seat Opened',
  PLAN_UPGRADE_ASSISTANT_SEAT_OPENED = 'Plan Upgrade Assistant Seat Opened',
  PLAN_ENTERPRISE_OPENED = 'Plan Enterprise Opened',
  PLAN_BILLING_HISTORY_OPENED = 'Plan Billing History Opened',
  PLAN_UPGRADE_PLAN_CHANGED = 'Plan Upgrade Plan Changed',
  PLAN_UPGRADE_SEAT_CHANGED = 'Plan Upgrade Seat Changed',
  PLAN_UPGRADE_ASSISTANT_SEAT_CHANGED = 'Plan Upgrade Assistant Seat Changed',
  PLAN_TRY_FOR_FREE_CLICK = 'Try For Free Clicked',
  PLAN_UPGRADE_CLICKED = 'Plan Upgrade Clicked',
  PLAN_DELTA_TRAL_STARTED = 'Plan Delta Tral Started',
  PLAN_DELTA_TRAL_CANCELED = 'Plan Delta Tral Canceled',

  // WALLET EVENTS
  WALLET_PURCHASE_OPENED = 'Wallet Purchase Opened',
  WALLET_PURCHASE_CONFIRMED = 'Wallet Purchase Confirmed',
  WALLET_CONFIG_SAVED = 'Wallet Config Saved',
  WALLET_AUTO_TOPUP_ENABLED = 'Wallet Auto Top-Up Enabled',
  WALLET_AUTO_TOPUP_DISABLED = 'Wallet Auto Top-Up Disabled',

  //Manage Team
  INVITE_USER_CLICKED = 'Invite user clicked',
  BULK_INVITE_USER_CLICKED = 'Bulk Invite clicked',
  INVITE_USER_SENT = 'Invite user sent',
  INVITE_REQUESTED = 'Invite requested',
  SEAT_ASSIGNED = 'Seat assigned',
  SEAT_PURCHASED = 'Seat purchased',
  SEATS_PURCHASED = 'Seats purchased',
  INVITE_REVOKED = 'Invite revoked',

  // Contacts
  ADD_CONTACT_CLICKED = 'Add contact clicked',
  CONTACT_ADDED = 'Contact added',
  CONTACT_TAB_CHANGED = 'Contact Tab Changed',

  //Setup
  PRESET_INSTALL_CLICKED = 'Preset Install Clicked',
  PRESET_UNINSTALL_CLICKED = 'Preset Uninstall Clicked',
  PRESET_FILTER_CLICKED = 'Preset Filter Clicked',
  PRESET_CONFIG_CLICKED = 'Preset Config CLicked',

  //Meeting scorecard
  MEETING_SCORECARD_SWITCHED = 'Meeting Scorecard Switched',

  // Meeting template
  MEETING_TEMPLATE_ACTIVATED = 'Meeting Template Activated',
  MEETING_TEMPLATE_DEACTIVATED = 'Meeting Template Deactivated',
  MEETING_TEMPLATE_CREATED = 'Meeting Template Created',
  MEETING_TEMPLATE_CREATED_FROM_SYSTEM = 'Meeting Template Created From System',
  MEETING_TEMPLATE_UPDATED = 'Meeting Template Updated',
  MEETING_TEMPLATE_COPIED = 'Meeting Template Copied',
  MEETING_TEMPLATE_DELETED = 'Meeting Template Deleted',
  MEETING_TEMPLATE_MIGRATION_CONFIRMED = 'Meeting Template Migration Confirmed',
  MEETING_TEMPLATE_MIGRATION_BACKUP_DOWNLOADED = 'Meeting Template Migration Backup Downloaded',
  MEETING_TEMPLATE_MIGRATION_BANNER_VIEWED = 'Meeting Template Migration Banner Viewed',

  // Email type
  EMAIL_TYPE_ACTIVATED = 'Email Type Activated',
  EMAIL_TYPE_DEACTIVATED = 'Email Type Deactivated',
  EMAIL_TYPE_CREATED = 'Email Type Created',
  EMAIL_TYPE_CREATED_FROM_SYSTEM = 'Email Type Created From System',
  EMAIL_TYPE_UPDATED = 'Email Type Updated',
  EMAIL_TYPE_COPIED = 'Email Type Copied',

  //Profile Settings
  DELETE_MY_ACCOUNT_CLICKED = 'Delete My Account Clicked',
  ZOOM_CONNECT_CLICKED = 'Zoom Connect Clicked',
  ZOOM_DISCONNECT_CLICKED = 'Zoom Disconnect Clicked',
  ZOOM_SETTINGS_OPENED = 'Zoom Settings Opened',
  ZOOM_SETTINGS_SAVED = 'Zoom Settings Saved',
  NOTIFICATION_REQUESTED = 'notification-requested',
  CLIENT_SIGNALS_ENABLED = 'client_signals_enabled',
  CLIENT_SIGNALS_EMAIL_ENABLED = 'client_signals_email_enabled',
  CLIENT_SIGNAL_EXPORT_ENABLED = 'client_signal_export_enabled',
  PROFILE_PHOTO_UPLOAD = 'Profile Photo Upload',

  //Share Zocks
  SHARE_ZOCKS_MODAL_OPEN = 'Share Zocks Opened',
  SHARE_ZOCKS_ON_SOCIAL = 'Share Zocks On Social Clicked',

  //In Person Meeting App
  IN_PERSON_MEETING_STARTED = 'In Person Meeting Started',
  IN_PERSON_MEETING_START_ERROR = 'In Person Meeting Start Error Encountered',
  IN_PERSON_MEETING_FINISHED = 'In Person Meeting Finished',
  ABORTED_IN_PERSON_MEETING_FINISHED = 'Aborted In Person Meeting Finished',
  IN_PERSON_MEETING_PAUSED = 'In Person Meeting Paused',
  IN_PERSON_MEETING_RESUMED = 'In Person Meeting Resumed',
  IN_PERSON_MEETING_CHUNK_UPLOAD_FAILED = 'In Person Meeting Chunk Upload Failed',
  IN_PERSON_MEETING_FINISHING_ERROR = 'In Person Meeting Finish Error Encountered',

  //CRM
  SAVE_MEETING_TO_CRM = 'Save meeting to CRM Clicked',
  SAVE_MEETING_SUMMARY_TO_CRM = 'Save meeting summary to CRM Clicked',
  SAVE_TASKS_TO_CRM = 'Save tasks to CRM Clicked',
  SAVE_NOTES_TO_CRM = 'Save notes to CRM Clicked',
  SAVE_EVENTS_TO_CRM = 'Save events to CRM Clicked',
  SAVE_RESULTS_TO_CRM = 'Save results to CRM Clicked',
  START_NEW_WORKFLOW_IN_CRM = 'Start new workflow in CRM clicked',
  UPDATE_WORKFLOW_STEP_IN_CRM = 'Update workflow step in CRM clicked',
  NOTIFY_USER_UTILIZED = 'Notify user utilized',
  MEETING_SUMMARY_EDITED_IN_MODAL = 'Meeting summary edited in modal',
  MEETING_EXPORT_EDITED = 'Meeting export edited',
  EXTERNAL_UPDATES_OPENED = 'External Updates Opened',
  CRM_LINK_CLICKED = 'CRM Link Clicked',

  // Email provider
  SAVE_RESULTS_TO_EMAIL_PROVIDER_CLICKED = 'Save results to email provider Clicked',
  AI_RESULT_PUSHED_AS_DRAFT_TO_EMAIL_PROVIDER = 'AI Result Pushed As Draft To Email Provider',
  AI_RESULT_SENT_TO_EMAIL_PROVIDER = 'AI Result Sent To Email Provider',

  // Integrations
  CONTACT_LINKED_TO_INTEGRATION = 'Contact Linked To Integration',
  SYNC_HISTORY_OPENED = 'Sync History Opened',
  CONNECT_TO_SYSTEM = 'Connect to system',
  PREDEFINED_INTEGRATION_CONFIG_EMAIL_FIELD_FILLED = 'Predefined integration config email field filled',
  PREDEFINED_INTEGRATION_CONFIG_HOUSEHOLD_FIELD_FILLED = 'Predefined integration config household field filled',
  PREDEFINED_INTEGRATION_CONFIG_SAVE_TO_HOUSEHOLD_TOGGLED = 'Predefined integration config save to household toggled',
  PREDEFINED_INTEGRATION_CONFIG_SESSION_OBJECT_MODIFIED = 'Predefined integration config session object modified',
  PREDEFINED_INTEGRATION_CONFIG_CONTACT_OBJECT_MODIFIED = 'Predefined integration config contact object modified',
  CUSTOM_INTEGRATION_CONFIG_CONTACT_OBJECT_MODIFIED = 'Custom integration config contact object modified',
  CUSTOM_INTEGRATION_CONFIG_SESSION_OBJECT_MODIFIED = 'Custom integration config session object modified',
  CUSTOM_INTEGRATION_CONFIG_CONTACT_FILTERS_MODIFIED = 'Custom integration config contact filters modified',
  CUSTOM_INTEGRATION_CONFIG_CONTACT_UPDATE_CONFIGURED = 'Custom integration config contact update configured',
  CUSTOM_INTEGRATION_CONFIG_UPDATE_MEETING_SUMMARY_CHECKED = 'Custom integration config update meeting summary checked',
  CUSTOM_INTEGRATION_CONFIG_SESSION_SAVE_TO_HOUSEHOLD_TOGGLED = 'Custom integration config session save to household toggled',
  CUSTOM_INTEGRATION_CONFIG_TASK_SAVE_TO_HOUSEHOLD_TOGGLED = 'Custom integration config task save to household toggled',
  CUSTOM_INTEGRATION_CONFIG_TASK_OBJECT_MODIFIED = 'Custom integration config task object modified',

  // Tasks
  TASK_CREATED = 'Task Created',
  TASKS_MERGED = 'Tasks merged',
  TASK_UPDATED = 'Task Updated',
  TASK_REASSIGNED = 'Task Reassigned',
  REDTAIL_TEMPLATE_SELECTED = 'Redtail Activity Template Selected',

  // Meeting Prep
  MEETING_PREP_OPENED = 'Meeting Prep Opened',
  MEETING_PREP_INTERACTED_WITH = 'Meeting Prep Interacted With',
  MEETING_PREP_COPIED = 'Meeting Prep Copied',
  MEETING_PREP_EMAIL_COPIED = 'Meeting Prep E-mail Copied',
  MEETING_PREP_RERUN = 'Meeting Prep Rerun',
  MEETING_PREP_MAILTO_CLICKED = 'Meeting Prep Mailto Clicked',
  MEETING_PREP_EXECUTED_ON_CONTACT = 'Meeting prep executed on contact',
  MEETING_PREP_EXECUTED_FROM_UPCOMING = 'Meeting prep executed from Upcoming',
  MEETING_PREP_EDITED_MANUALLY = 'Meeting prep edited manually',
  MEETING_PREP_TAB_CHANGED = 'Meeting Prep Tab Changed',
  MEETING_PREP_ARCHIVE_VIEWED = 'Meeting Prep Archive Viewed',
  MEETING_PREP_ARCHIVE_COPIED = 'Meeting Prep Archive Copied',
  MEETING_PREP_ARCHIVE_PDF_EXPORTED = 'Meeting Prep Archive PDF Exported',
  MEETING_PREP_ARCHIVE_SAVED_TO_INTEGRATION = 'Meeting Prep Archive Saved To Integration',

  //Suggested Workflow
  SUGGESTED_WORKFLOW_RERUN = 'Suggested Workflow Rerun',
  INTEGRATION_WORKFLOWS_OPENED = 'Integration Workflows Opened',

  // CRM Contact Update
  CRM_CONTACT_UPDATE_OPENED = 'CRM Contact Update Opened',
  CRM_CONTACT_UPDATE_RERUN = 'CRM Contact Update Rerun',
  CRM_CONTACT_UPDATE_SAVED = 'CRM Contact Update Saved',
  CRM_CONTACT_UPDATE_FIELD_SELECTED = 'CRM Contact Update Field Selected',
  CONTACT_UPDATE_SECTIONS_UNCHECKED = 'Contact update sections unchecked',
  CONTACT_UPDATE_RESULTS_CREATED = 'Contact update results created',
  CONTACT_UPDATE_RESULTS_EDITED = 'Contact update results edited',
  CONTACT_UPDATE_RESULTS_EXPLAINED = 'Contact Update Result Explained',
  EXTERNAL_CONTACT_CREATED = 'External Contact Created',
  CONTACT_UPDATE_CHANGELOG_OPENED = 'Contact Update Changelog Opened',
  CONTACT_UPDATE_CHANGELOG_COPIED = 'Contact Update Changelog Copied',

  // Meeting Summary
  MEETING_SUMMARY_TAB_CHANGED = 'Meeting Summary Tab Changed',
  MEETING_SUMMARY_AGENT_INTERACT = 'Meeting Summary Agent Interact',
  MEETING_SUMMARY_AGENT_INTERACT_STREAMING = 'Meeting Summary Agent Interact (Streaming)',
  MEETING_SUMMARY_AGENT_RERUN = 'Meeting Summary Agent Rerun',
  MEETING_SUMMARY_AGENT_RESULT_COPIED = 'Meeting Summary Agent Result Copied',
  MEETING_SUMMARY_AGENT_CHAT_CLICKED = 'Meeting Summary Agent Chat Clicked',
  MEETING_SUMMARY_AGENT_FEATURE_PIN_CLICKED = 'Meeting Summary Agent Feature Pin Clicked',
  MEETING_SUMMARY_FIND_AND_REPLACE = 'Meeting Summary Find and Replace',

  // AI Agent
  AI_AGENT_USER_ACTION_BUTTON_CLICKED = 'AI Agent User Action Button Clicked',

  // Email Response
  EMAIL_RESPONSE_EXECUTED = 'Email Response Executed',
  EMAIL_RESPONSE_INTERACTED_WITH = 'Email Response Interacted With',
  EMAIL_RESPONSE_COPIED = 'Email Response Copied',
  EMAIL_RESPONSE_PUSHED_TO_DRAFT = 'Email Response Pushed To Draft',
  EMAIL_RESPONSE_SENT = 'Email Response Sent',
  EMAIL_RESPONSE_EMAIL_TYPE_CHANGED = 'Email Response Email Type Changed',
  EMAIL_CONSENT_SETTINGS_CHANGED = 'Email Consent Settings Changed',
  EMAIL_AUTOMATION_SETTINGS_CHANGED = 'Email Automation Settings Changed',
  EMAIL_AUTOMATION_USER_SETTINGS_CHANGED = 'Email Automation User-Level Settings Changed',
  EMAIL_AUTOMATION_UNCATEGORIZED_ACTION_CHANGED = 'Email Automation Uncategorized Action Changed',
  EMAIL_CLIENT_PROFILE_CHANGES_OPENED = 'Email Profile Changes Opened',
  EMAIL_CONTACT_UPDATE_OPENED = 'Email Contact Update Opened',

  // Phone
  PHONE_START_CALL = 'Phone Start Call',
  PHONE_ADD_TO_ONGOING_CALL = 'Phone Add to Ongoing Call',

  // Citation
  CITATION_OPENED = 'Citation Opened',
  // Client-profile
  CLIENT_PROFILE_INITIAL_CRM_SYNC_EXECUTED = 'Client Profile Initial CRM Sync Executed',

  // New Email

  NEW_EMAIL_OPENED = 'New Email Opened',
  NEW_EMAIL_EXECUTED = 'New Email Executed',
  NEW_EMAIL_INTERACTED_WITH = 'New Email Interacted With',
  NEW_EMAIL_COPIED = 'New Email Copied',
  NEW_EMAIL_MAILTO_CLICKED = 'New Email Mailto Clicked',
  NEW_EMAIL_PUSHED_TO_DRAFT = 'New Email Pushed To Draft',
  NEW_EMAIL_SENT = 'New Email Sent',

  // Document type
  DOCUMENT_TYPE_ACTIVATED = 'Document Type Activated',
  DOCUMENT_TYPE_DEACTIVATED = 'Document Type Deactivated',
  DOCUMENT_TYPE_CREATED = 'Document Type Created',
  DOCUMENT_TYPE_CREATED_FROM_SYSTEM = 'Document Type Created From System',
  DOCUMENT_TYPE_UPDATED = 'Document Type Updated',
  DOCUMENT_TYPE_COPIED = 'Document Type Copied',

  // Document Summary

  PROCESS_DOCUMENTS_CLICKED = 'Process Documents Clicked',
  EMAIL_ATTACHMENT_SUGGESTIONS_SHOWN = 'Email Attachment Suggestions Shown',
  EMAIL_ATTACHMENT_ADDED = 'Email Attachment Added',
  DOCUMENT_FILE_TOO_LARGE = 'Document File Too Large',
  DOCUMENT_FILE_PASSWORD_PROTECTED_TOO_LARGE = 'Document File Password Protected Too Large',
  DOCUMENT_OPENED = 'Document Opened',
  DOCUMENT_SUMMARY_INTERACTED_WITH = 'Document Summary Interacted With',
  DOCUMENT_BATCH_CHAT_INTERACTED_WITH = 'Document Batch Chat Interacted With',
  DOCUMENT_SUMMARY_TYPE_CHANGED = 'Document Summary Type Changed',
  DOCUMENT_SUMMARY_SAVED = 'Document Summary Saved',
  DOCUMENT_CONTACT_UPDATED = 'Document Contact Updated',

  LOCKED_DOCUMENT_ENTER_PASSWORD_CLICKED = 'Locked Document Enter Password Clicked',
  LOCKED_DOCUMENT_UNLOCK_CLICKED = 'Locked Document Unlock Clicked',
  LOCKED_DOCUMENT_APPLY_TO_ALL_CLICKED = 'Locked Document Apply To All Clicked',
  LOCKED_DOCUMENT_SKIP_CLICKED = 'Locked Document Skip Clicked',
  DOCUMENT_UNLOCKED = 'Document Unlocked',

  // Document Connectors

  DOCUMENT_FOLDER_MAPPED_TO_CONTACT = 'Document folder mapped to contact',
  DOCUMENT_UPLOADED_FROM_EXTERNAL_SOURCE = 'Document uploaded from external source',
  DOCUMENT_EXPORTED = 'Document exported',

  // Document Prospecting

  DOCUMENT_PROSPECTING_STARTED = 'Document Prospecting Started',
  DOCUMENT_PROSPECTING_FILE_ADDED = 'Document Prospecting File Added',
  DOCUMENT_PROSPECTING_FILE_TOO_LARGE = 'Document Prospecting File Too Large',
  DOCUMENT_PROSPECTING_EXTERNAL_SYSTEM_SELECTED = 'Document Prospecting External System Selected',
  DOCUMENT_PROSPECTING_CONTACT_CONFIRMED = 'Document Prospecting Contact Confirmed',
  DOCUMENT_PROSPECTING_FIELDS_CONFIRMED = 'Document Prospecting Fields Confirmed',
  DOCUMENT_PROSPECTING_COMPLETED = 'Document Prospecting Completed',

  // Input parameters hierarchy
  INPUT_PARAMETERS_HIERARCHY_NODE_CREATED = 'Created Input Parameter Hierarchy Node',
  INPUT_PARAMETERS_HIERARCHY_NODE_REMOVED = 'Removed Input Parameter Hierarchy Node',
  INPUT_PARAMETERS_HIERARCHY_NODE_UPDATED = 'Updated Input Parameter Hierarchy Node',

  // Agenda
  AGENDA_SHOW_REVIEW_MODAL_CLICKED = 'Show Agenda Review Modal Clicked',
  AGENDA_TOGGLE_CLICKED = 'Agenda Toggle Clicked',
  AGENDA_ITEM_ADDED = 'Agenda Item Added',
  AGENDA_ITEM_TEXT_UPDATED = 'Agenda Item Text Updated',
  AGENDA_ITEM_STATUS_UPDATED = 'Agenda Item Status Updated',
  AGENDA_ITEM_DELETED = 'Agenda Item Deleted',
  AGENDA_ITEMS_REORDERED = 'Agenda Items Reordered',

  // Academy
  ZOCKS_ACADEMY_CLICKED = 'Zocks Academy Clicked',

  // Cross-Client
  X_CLIENT_OPENED = 'X-Client Opened',
  X_CLIENT_QUERY_SUBMITTED = 'X-Client Query Submitted',
  X_CLIENT_QUERY_CONFIRMED = 'X-Client Query Confirmed',
  X_CLIENT_QUERY_STOPPED = 'X-Client Query Stopped',
  X_CLIENT_QUERY_DELETED = 'X-Client Query Deleted',
  X_CLIENT_QUERY_RERUN = 'X-Client Query Rerun',
  X_CLIENT_QUERY_DENIED = 'X-Client Query Denied',
  X_CLIENT_RESULT_READY = 'X-Client Result Ready',
  X_CLIENT_RESULT_EXPORTED = 'X-Client Result Exported',
  X_CLIENT_HISTORY_OPENED = 'X-Client History Opened',
  X_CLIENT_QUERY_VIEW_MATCH = 'X-Client Query View Match',
  X_CLIENT_ACTIONS_CLICKED = 'X-Client Actions Clicked',
  X_CLIENT_ACTIONS_SUBMITTED = 'X-Client Actions Submitted',
  X_CLIENT_QUESTION_REJECTED = 'X-Client Question Rejected',
  X_CLIENT_QUESTION_CORRECTED = 'X-Client Question Corrected',
  X_CLIENT_QUESTION_REFINED = 'X-Client Question Refined',
  X_CLIENT_QUESTION_REFINEMENT_MISSING = 'X-Client Question Refinement Missing',
  X_CLIENT_QUESTION_SPECIFIED = 'X-Client Question Specified',
  X_CLIENT_QUESTION_OUTCOME_UNRECOGNISED = 'X-Client Question Outcome Unrecognised',
  X_CLIENT_SUGGESTION_ACCEPTED = 'X-Client Suggestion Accepted',
  X_CLIENT_SUGGESTION_EDITED = 'X-Client Suggestion Edited',
  X_CLIENT_SUGGESTION_DECLINED = 'X-Client Suggestion Declined',
  X_CLIENT_SUGGESTION_ABANDONED = 'X-Client Suggestion Abandoned',
  X_CLIENT_RECOMMENDED_QUERY_SELECTED = 'X-Client Recommended Query Selected',
  X_CLIENT_QUERY_LIBRARY_BROWSED = 'X-Client Query Library Browsed',
  X_CLIENT_REJECTION_DISMISSED = 'X-Client Rejection Dismissed',
  X_CLIENT_QUERY_PREVIEW_CANCELLED = 'X-Client Query Preview Cancelled',

  // Form template

  FORM_TEMPLATE_CREATED = 'Form Template Created',
  FORM_TEMPLATE_FILLED_OUT = 'Form Template Filled Out',

  // Multi Language Support
  CHANGE_MEETING_LANGUAGE_MODAL_CLICKED = 'Change Meeting Language Modal Clicked',
  MULTI_LANGUAGE_SETTING_CHANGED = 'Multi Language setting changed',
  MULTI_LANGUAGE_SETTING_FALLBACK_OPTION_CHANGED = 'Multi Language setting fallback option changed',
  MEETING_LANGUAGE_CONFIRMED = 'Meeting language confirmed',
  MEETING_LANGUAGE_CALCULATED = 'Meeting language calculated',

  // Template Library
  TEMPLATE_OPENED = 'Template Opened',
  TEMPLATE_SAVED = 'Template Saved',
  TEMPLATE_DUPLICATED = 'Template Duplicated',
  TEMPLATE_ASSIGNED = 'Template Assigned',
  TEMPLATE_ASSIGNMENT_REMOVED = 'Template Assignment Removed',
  TEMPLATE_ACCESS_CHANGED = 'Template Access Changed',
  TEMPLATE_DELETED = 'Template Deleted',
  NEW_TEMPLATE_CREATED = 'New Template Created',

  // Past Meetings Search

  PAST_MEETINGS_SEARCH = 'Past Meeting Search',

  // Delegated email
  DELEGATED_EMAIL_ADD = 'Add Delegated Email clicked',
  DELEGATED_EMAIL_REMOVE = 'Remove Delegated Email clicked',
  DELEGATED_EMAIL_SEND_CODE = 'Send code for Delegated Email clicked',

  // Insights

  INSIGHTS_TIME_RANGE_CHANGED = 'Insights Time Range Changed',
  INSIGHTS_ADVISOR_FILTER_CHANGED = 'Insights Advisor Filter Changed',
  INSIGHTS_TAB_CHANGED = 'Insights Tab Changed',
  INSIGHTS_SORT_CHANGED = 'Insights Sort Changed',
  INSIGHTS_FEEDBACK_OPENED = 'Insights Feedback Opened',
  INSIGHTS_FEEDBACK_DISMISSED = 'Insights Feedback Dismissed',
  INSIGHTS_EXPORTED = 'Insights Exported',
  MEETING_PREP_INSIGHTS_LINK_CLICKED = 'Insights Meeting Prep Link Clicked',
  MEETING_PREP_LIKELY_QUESTIONS_EXPANDED = 'Meeting Prep Likely Questions Expanded',
  INSIGHTS_SCORECARD_DETAILS_OPENED = 'Insights Scorecard Details Opened',
  INSIGHTS_DIGEST_SCHEDULE_CHANGED = 'Insights Digest Schedule Changed',

  // Participants
  PARTICIPANT_ADDED = 'Participant Added',

  // User Consent
  CONSENT_CHANGED = 'User Consent Changed',

  // Template Generator
  TEMPLATE_GENERATOR_EXECUTED = 'Template Generator Executed',
  TEMPLATE_GENERATOR_INTERACTED_WITH = 'Template Generator Interacted With',

  // Transcripts
  TRANSCRIPT_SETTINGS_MCP_PROMO_CLICKED = 'Transcript Settings MCP Promo Clicked',
  TRANSCRIPT_ACCESS_ENABLED = 'Transcript Access Enabled',
  PAST_MEETINGS_TRANSCRIPT_TAB_CLICKED = 'Past Meetings Transcript Tab Clicked',
  PAST_MEETINGS_TRANSCRIPT_TAB_MCP_PROMO_CLICKED = 'Past Meetings Transcript Tab MCP Promo Clicked',
  TRANSCRIPT_DOWNLOAD_CLICKED = 'Transcript Download Clicked',
  TRANSCRIPT_DOWNLOAD_FEEDBACK_INTERACTED = 'Transcript Download Feedback Interacted',

  // Account Settings
  SETTINGS_TAB_CHANGED = 'Settings Tab Changed',

  // Account Opening
  ACCOUNT_OPENING_CLICKED = 'Account Opening Clicked',
  ACCOUNT_OPENING_STARTED = 'Account Opening Started',
  ACCOUNT_OPENING_VALIDATED = 'Account Opening Validated',
  ACCOUNT_OPENING_SUBMITTED = 'Account Opening Submitted',
  ACCOUNT_OPENING_RESUMED = 'Account Opening Resumed',
  ACCOUNT_OPENING_SUBMITTED_ENVELOPE_CHECKED = 'Account Opening Submitted Envelope Checked',
  ACCOUNT_OPENING_DELETED = 'Account Opening Deleted',

  // Scheduling
  SCHEDULING_ACCOUNT_SETTINGS_UPDATED = 'Scheduling Account Settings Updated',
  SCHEDULING_USER_SETTINGS_UPDATED = 'Scheduling User Settings Updated',
  SCHEDULING_USER_SETTINGS_RESET = 'Scheduling User Settings Reset',
  SCHEDULING_EVENT_TYPE_CREATED = 'Scheduling Event Type Created',
  SCHEDULING_EVENT_TYPE_UPDATED = 'Scheduling Event Type Updated',
  SCHEDULING_EVENT_TYPE_DUPLICATED = 'Scheduling Event Type Duplicated',
  SCHEDULING_EVENT_TYPE_DELETED = 'Scheduling Event Type Deleted',
  SCHEDULING_EVENT_TYPES_ADDED_TO_BOOKING_PAGE = 'Scheduling Event Types Added To Booking Page',
  SCHEDULING_EVENT_TYPE_REMOVED_FROM_BOOKING_PAGE = 'Scheduling Event Type Removed From Booking Page',
  SCHEDULING_LOCATION_CREATED = 'Scheduling Location Created',
  SCHEDULING_LOCATION_UPDATED = 'Scheduling Location Updated',
  SCHEDULING_LOCATION_DELETED = 'Scheduling Location Deleted',
  SCHEDULING_LOCATION_SET_AS_DEFAULT = 'Scheduling Location Set As Default',
  SCHEDULING_FILTERS_CHANGED = 'Scheduling Filters Changed',
  SCHEDULING_INVITATION_SENT = 'Scheduling Invitation Sent',
  SCHEDULING_MEETING_RESCHEDULED = 'Scheduling Meeting Rescheduled',
  SCHEDULING_MEETING_CANCELLED = 'Scheduling Meeting Cancelled',
  SCHEDULING_REQUEST_ACCEPTED = 'Scheduling Request Accepted',
  SCHEDULING_REQUEST_DECLINED = 'Scheduling Request Declined',
  SCHEDULING_SUGGESTION_DISMISSED = 'Scheduling Suggestion Dismissed',
  SCHEDULING_BOOKING_ARCHIVED = 'Scheduling Booking Archived',
  SCHEDULING_REMINDER_SENT = 'Scheduling Reminder Sent',
  SCHEDULING_REMINDERS_ENABLED = 'Scheduling Reminders Enabled',
  SCHEDULING_REMINDERS_DISABLED = 'Scheduling Reminders Disabled',
  SCHEDULING_REMINDER_SETTINGS_UPDATED = 'Scheduling Reminder Settings Updated',
  SCHEDULING_BOOKING_PAGE_UPDATED = 'Scheduling Booking Page Updated',
  SCHEDULING_BOOKING_LINK_COPIED = 'Scheduling Booking Link Copied',
  SCHEDULING_JOIN_LINK_COPIED = 'Scheduling Join Link Copied',
  SCHEDULING_BOOKING_PAGE_VIEWED = 'Scheduling Booking Page Viewed',
  SCHEDULING_INVITATION_EMAIL_COPIED = 'Scheduling Invitation Email Copied',
  SCHEDULING_INVITATION_PUSHED_TO_DRAFT = 'Scheduling Invitation Pushed To Draft',
}

export enum OnboardingTrackEvent {
  ONBOARDING_PRESETS_DONE = 'onboarding-presets-done',
  ZOOM_CONNECTED = 'zoom-connected',
  CALENDAR_CONNECTED = 'calendar-connected',
  DEMO_MEETING_VIEWED = 'demo-meeting-viewed',
  SUMMARY_AGENT_VIDEO_VIEWED = 'summary-agent-video-viewed',
  DISMISS_ONBOARDING_ITEM = 'onboarding-item-dismissed',
  ONBOARDING_PRESETS_DISMISSED = 'onboarding-presets-dismissed',
  ONBOARDING_ZOOM_INTEGRATION_DISMISSED = 'onboarding-zoom-integration-dismissed',
  ONBOARDING_CALENDAR_INTEGRATION_DISMISSED = 'onboarding-calendar-integration-dismissed',
  ONBOARDING_DEMO_MEETING_VIEWED_DISMISSED = 'onboarding-demo-meeting-dismissed',
  ALL_DISMISSED = 'onboarding-all-items-dismissed',
  LIVE_MEETINGS_VIDEO_VIEWED = 'live-meetings-video-viewed',
  WEBEX_CONNECTED = 'webex-connected',
}

export enum GrowthTrackEvent {
  ONBOARDING_CALENDAR_INTEGRATION_CLICKED = 'Onboarding Calendar Integration Clicked',
  ONBOARDING_CONTACT_SOURCE_INTEGRATION_CLICKED = 'Onboarding Contact Source Integration Clicked',
  ONBOARDING_FINANCIAL_PLANNING_INTEGRATION_CLICKED = 'Onboarding Financial Planning Integration Clicked',
  ONBOARDING_MAIL_INTEGRATION_CLICKED = 'Onboarding Mail Integration Clicked',
  ONBOARDING_ZOOM_CLICKED = 'Onboarding Zoom Clicked',

  ONBOARDING_FINISH_SETUP_CLICKED = 'Onboarding Finish Setup Clicked',

  ONBOARDING_DISMISS_CONFIRM_BACK_TO_SETUP_CLICKED = 'Onboarding Dismiss Modal Back To Setup Clicked',
  ONBOARDING_DISMISS_CONFIRM_LEAVE_SETUP_CLICKED = 'Onboarding Dismiss Modal Leave Setup Clicked',

  ONBOARDING_COMPLETED_SKIP_CLICKED = 'Onboarding Completed Modal Skip Clicked',
  ONBOARDING_COMPLETED_VIEW_COURSES_CLICKED = 'Onboarding Completed Modal View Courses Clicked',

  CONTACTS_EMPTY_STATE_INTEGRATION_CLICKED = 'Contacts Empty State Integration Clicked',
  CONTACTS_FINANCIAL_PLANNING_BANNER_CONNECT_CLICKED = 'Contacts Financial Planning Banner Connect Clicked',

  UPCOMING_EMPTY_STATE_CALENDAR_INTEGRATION_CLICKED = 'Upcoming Empty State Calendar Integration Clicked',
  UPCOMING_ZOOM_BANNER_CLICKED = 'Upcoming Zoom Banner Clicked',
  UPCOMING_EMAIL_BANNER_INTEGRATION_CLICKED = 'Upcoming Email Banner Integration Clicked',

  CALENDAR_POST_CONNECT_DONE_CLICKED = 'Calendar Post-Connect Done Clicked',
  CALENDAR_POST_CONNECT_EVENT_FILTERS_CLICKED = 'Calendar Post-Connect Exit To Event Filters Clicked',
  CONTACTS_POST_CONNECT_DONE_CLICKED = 'Contacts Post-Connect Done Clicked',
  POST_CONNECT_CLOSE_CLICKED = 'Post-Connect Close Prematurely Clicked',

  MCP_USER_PROMO_CLICKED = 'MCP User Promo Clicked',
  MCP_ADMIN_PROMO_CLICKED = 'MCP Admin Promo Clicked',
}

export enum AIResultMetadataType {
  COPY = 'copy',
  EMAIL = 'email',
}

// Where a tracked interaction originates from (a page, tab or surface); provided via TrackingSourceContext and sent as the `source` event property
export type TrackingSource = 'meetingPrepPage' | 'contactPage'
